export default __webpack_public_path__ + "static/media/Proreview-2.b54b7284.jpg";